import { render, staticRenderFns } from "./ProductRegions.vue?vue&type=template&id=06ea0ca5&"
import script from "./ProductRegions.vue?vue&type=script&lang=js&"
export * from "./ProductRegions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports